import React from 'react';
import { TemplateRenderProps } from './types';
import { FormFields, AddonsSelector, CouponSection, TrustAndSecurityBadge, SocialProofAndFomo } from './CheckoutCommonElements';
import { BillingCycleSelector, PriceBreakdown } from './CheckoutSummaryElements';

export const FloatingTemplate: React.FC<TemplateRenderProps> = ({
  plan,
  config,
  formData,
  onInputChange,
  billingCycle,
  onChangeCycle,
  selectedAddonIds,
  onToggleAddon,
  appliedCoupon,
  onApplyCoupon,
  onRemoveCoupon,
  onSubmitInfo,
  isCapturing,
  currencySymbol,
  addonsTotal,
  discountAmount,
  finalTotal,
}) => {
  return (
    <div
      className="min-h-full p-4 md:p-10 flex items-center justify-center relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #ffedd5 0%, #fed7aa 50%, #fdba74 100%)',
        color: '#1e293b',
        fontFamily: config.fontFamily || 'Inter, sans-serif',
      }}
    >
      <div className="w-full max-w-xl bg-white rounded-3xl shadow-[0_25px_60px_-15px_rgba(249,115,22,0.3)] border border-orange-100 p-6 md:p-8 space-y-6">
        <div className="flex items-center justify-between">
          {config.logoUrl && <img src={config.logoUrl} alt="Logo" className="h-6 object-contain" />}
          <span className="px-3 py-1 bg-orange-100 text-orange-700 text-xs font-black rounded-full uppercase tracking-wider">
            {plan.tier} Tier
          </span>
        </div>

        <div className="text-center space-y-1">
          <h1 className="text-2xl font-black text-slate-900">{config.headerMain || 'Express Checkout'}</h1>
          <p className="text-xs text-slate-500">{config.headerSub || 'Complete order below for immediate access.'}</p>
        </div>

        <div className="bg-orange-50/70 p-4 rounded-2xl border border-orange-100 space-y-4">
          <BillingCycleSelector billingCycle={billingCycle} onChangeCycle={onChangeCycle} config={config} />
          <PriceBreakdown plan={plan} billingCycle={billingCycle} addonsTotal={addonsTotal} discountAmount={discountAmount} finalTotal={finalTotal} currencySymbol={currencySymbol} />
        </div>

        <SocialProofAndFomo config={config} />

        <form onSubmit={onSubmitInfo} className="space-y-4">
          <FormFields config={config} formData={formData} onInputChange={onInputChange} />
          <AddonsSelector addons={config.addons} selectedAddonIds={selectedAddonIds} onToggleAddon={onToggleAddon} currency={plan.currency} />
          <CouponSection config={config} appliedCoupon={appliedCoupon} onApplyCoupon={onApplyCoupon} onRemoveCoupon={onRemoveCoupon} />

          <button
            type="submit"
            disabled={isCapturing}
            className="w-full py-4 text-xs font-black uppercase tracking-wider text-white shadow-xl transition-all hover:opacity-95 active:scale-[0.99] disabled:opacity-50"
            style={{
              backgroundColor: config.primaryColor || '#f97316',
              borderRadius: config.buttonRadius || '14px',
            }}
          >
            {isCapturing ? 'Activating...' : config.buttonText || `Pay ${currencySymbol}${finalTotal.toFixed(2)}`}
          </button>
        </form>

        <TrustAndSecurityBadge config={config} />
        {config.footerText && <p className="text-[10px] text-slate-400 text-center">{config.footerText}</p>}
      </div>
    </div>
  );
};
